import { useNode } from '@craftjs/core';

export default function Droppable({ children, className, ...props }) {
  const { connectors: { connect } } = useNode();

  return <div ref={connect} className={`${className}`} {...props}>
    {children}
  </div>
}

export function wrappDroppable(Component) {
  return function DroppableComponent(props) {
    return <Droppable>
      <Component {...props} />
    </Droppable>
  }
}
